import { Unit } from "@shared/api/types"

export enum DeclarationType {
	CustomerProject = "customerProject",
	InternalProject = "internalProject",
}

export type SelectionOfDeclarationTypeFormState = {
	declarationType: DeclarationType
	projectId?: string
	project: string
}

export type SelectionOfDeclarationFormInputs = {
	declarationType: DeclarationType
	projectId?: string
	project?: string
	newProject?: string
}

export type SelectionOfMaterialFormState = {
	materialNumber: string
	contractNumber: string
	materialDescription: string
	customerId: string
	quantity: number
	totalQuantity: number
	savings: number
	nonTransferableSavings?: number
	unit: Unit
}

export type SelectionOfMaterialFormInputs = {
	material: string
	quantity: number
}

export type DeclarationDetailsFormState = {
	project: string
	companyName: string
	street: string
	zipCode: string
	city: string
	country: string
}

export type DeclarationDetailsFormInputs = {
	project?: string
	companyName?: string
	street?: string
	zipCode?: string
	city?: string
	country?: string
}
